import {
  getFirstAttributeValue,
  type Product,
  type Variant,
} from '@scayle/storefront-nuxt'

export {}

declare global {
  type VariantWithProduct = Variant & { product: Product }
}

export function getSizeLabel(variant: Variant) {
  const attributes = variant?.attributes
  const categorySize = getFirstAttributeValue(attributes, 'sizeCategorySize')
  const label = categorySize?.label.split('|')[1]

  if (label) return label

  const sizeAttribute = getFirstAttributeValue(attributes, 'size')?.label
  return sizeAttribute ? 'EU' + sizeAttribute : ''
}

/**
 * Returns a URL-safe size parameter for the variant (e.g. "48", "75-B").
 * Used for size-specific PDP URLs (?size=48).
 * Commas are normalized to dots so locale-formatted sizes like "5,5"
 * become "5.5" — commas are unreliable in URLs.
 */
export function getSizeParamFromVariant(variant: Variant): string {
  if (!variant?.attributes) return ''
  const label = getSizeLabel(variant)
  if (label) return normalizeSize(label)
  return variant.id != null ? String(variant.id) : ''
}

export function normalizeSize(value: string): string {
  return value.replace(/,/g, '.').replace(/\//g, '-').replace(/\s/g, '')
}
